import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { loginAuth } from './redux/authApi';
import { useUnamePass } from '../common/helpers/othersHelpers';
import BodyAuth from './part/BodyAuth';
import RegisterParents from './part/RegisterParents';
import LoadingButton from '../common/layout/LoadingButton';
import Herobody from './part/Herobody';
import SectionBody from './part/SectionBody';
import { useWindowSize } from '../common/helpers/sizeHelper';
import LoginForm from './LoginForm';

function mapState(state) {
  return {
    auth: state.auth,
    loading: state.async.loading,
  };
}

const actions = {
  loginAuth,
};

function Login(props) {
  const { loginAuth, handleSubmit, auth, loading } = props;
  let uPass = useUnamePass();

  let windowSize = useWindowSize();

  const handleLogin = (authData) => {
    loginAuth(authData);
  };

  if (auth && auth.isAuth && !auth.registerParents)
    return <Redirect to='/dashboard' />;
  if (auth && auth.isAuth && auth.registerParents)
    return <Redirect to='/register-2' />;

  if (uPass)
    return (
      <SectionBody>
        <Herobody
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#ffffff',
          }}
        >
          <LoadingButton />
        </Herobody>
      </SectionBody>
    );

  return (
    <BodyAuth
      title={'Selamat Datang di Portal Sekolah'}
      width={
        windowSize[0] < 400 ? (windowSize[0] > 365 ? 365 : windowSize[0]) : 400
      }
    >
      <LoginForm
        loading={loading}
        initialValues={{ username: '', password: '' }}
        onSubmit={handleSubmit}
        onLogin={handleLogin}
      />
      <RegisterParents />
    </BodyAuth>
  );
}

export default withRouter(connect(mapState, actions)(Login));
